import * as React from 'react';
import { Redirect, RedirectProps, Route, Switch } from 'react-router';
import { App } from './components/app/app';
import { Expired } from './components/expired/expired';
import { Segment } from './components/segment/segment';
import { Login } from './components/login/login';
import { Redeem } from './components/redeem/redeem';
import { withProps } from './utils/compose';

export function Router() {
  return (
    <App>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/segment" component={Segment} />
        <Route path="/expired/:passengerID" component={Expired} />
        <Route path="/redeem/:passengerID" component={Redeem} />
        <Route
          exact={true}
          path="/"
          component={withProps<RedirectProps>(Redirect, { to: '/login' })}
        />
        <Redirect to="/login" />
      </Switch>
    </App>
  );
}



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/routes.tsx